import { Bonus } from '../bonus';

export enum SaleBonusSource {
  Code = 'code',
  Admin = 'admin',
  /** Tipsbelöning: earned when a sale created with this sale's referral code qualified. */
  Commission = 'commission',
}

export interface SaleBonus extends Bonus {
  id: string;
  /** Counts toward the profit: not revoked and threshold reached. */
  applied: boolean;
  source: SaleBonusSource;
  bonusCodeId: string | null;
  /** For commission bonuses, the friend's sale that earned it. */
  qualifiedSaleId: string | null;
  grantedAt: string;
  revokedAt: string | null;
}
